const sliders = document.querySelectorAll(".products-slider");

sliders.forEach(function (el) {
  let swiper = new Swiper(el, {
    spaceBetween: 20,
    lazy: true,

    pagination: {
      el: ".swiper-pagination",
      type: "custom",
      renderCustom: function (swiper, current, total) {
        return Number(current) + " | " + Number(total);
      },
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    scrollbar: {
      el: ".swiper-scrollbar",
      dragSize: 50,
      draggable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
      },

      480: {
        slidesPerView: 1.3,
      },

      640: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
    },
  });
});
